module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default; 
    ; __append("\r\n")
    ;  
    let localizedText = u.getLocalizedText(id, 'text') || text;  

    ; __append("\r\n<div id=\"")
    ; __append(escapeFn( id ))
    ; __append("\" class=\"pf-control pf-editable button has-menu\" tabindex=\"")
    ; __append(escapeFn( tabIndex ))
    ; __append("\" draggable=\"true\"\r\n     style=\"left:")
    ; __append(escapeFn( left ))
    ; __append("px; top:")
    ; __append(escapeFn( top ))
    ; __append("px;\r\n             width: ")
    ; __append(escapeFn( u.extractNum(width)))
    ; __append("px; height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\r\n             z-index:")
    ; __append(escapeFn( zOrder ))
    ; __append(";\">\r\n\r\n    <div class=\"size-handle-top\"    style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-left\"   style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n\r\n        <div class=\"pf-control-core pf-selectable\" style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px; min-height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px; width: ")
    ; __append(escapeFn( u.extractNum(width) ))
    ; __append("px;\r\n                overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\r\n                font-family: ")
    ; __append(escapeFn(u.resolveCompliantFontFamilyName(fontFamily)))
    ; __append("; font-size: ")
    ; __append(escapeFn(fontSize))
    ; __append("px;\r\n                font-style: ")
    ; __append(escapeFn(textStyle))
    ; __append("; font-weight: ")
    ; __append(escapeFn(textWeight))
    ; __append("; color: ")
    ; __append(escapeFn( styleColorText))
    ; __append(";\r\n                -webkit-border-radius: ")
    ; __append(escapeFn(cornerRadius))
    ; __append("px;\r\n                -moz-border-radius: ")
    ; __append(escapeFn(cornerRadius))
    ; __append("px;\r\n                border-radius: ")
    ; __append(escapeFn(cornerRadius))
    ; __append("px;\r\n                border: 1px ")
    ; __append(escapeFn(borderStyle))
    ; __append(" ")
    ; __append(escapeFn(borderColor))
    ; __append(";\r\n                background: ")
    ; __append(escapeFn(backgroundColor))
    ; __append(";\r\n                background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(")
    ; __append(escapeFn(backgroundColor))
    ; __append("), to(")
    ; __append(escapeFn(advancedBgGradientColor))
    ; __append("));\r\n                background: -webkit-linear-gradient(0% 0%, 0% 100%, from(")
    ; __append(escapeFn(backgroundColor))
    ; __append("), to(")
    ; __append(escapeFn(advancedBgGradientColor))
    ; __append("));\r\n                background: -moz-linear-gradient(center top, ")
    ; __append(escapeFn(backgroundColor))
    ; __append(", ")
    ; __append(escapeFn(advancedBgGradientColor))
    ; __append(");\r\n                background: linear-gradient(to bottom, ")
    ; __append(escapeFn(backgroundColor))
    ; __append(", ")
    ; __append(escapeFn(advancedBgGradientColor))
    ; __append(");\r\n                text-align: center;line-height: ")
    ; __append(escapeFn( u.extractNum(height)-2))
    ; __append("px;\">\r\n            <div class=\"i\" style=\"vertical-align: middle; padding: 0px 6px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\">")
    ; __append(escapeFn( localizedText ))
    ; __append("</div>\r\n            <div class=\"i\" style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;width:0px;display:inline-block;vertical-align: middle;\"></div>\r\n        </div>\r\n\r\n\r\n    <div class=\"size-handle-right\"  style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-bottom\" style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  ))
    ; __append("px;\"></div>\r\n</div>\r\n\r\n\r\n")
  }
  return __output;

}